export const primaryColor = "#3b4a57";
export const themeLightGray = "#e0e6ed";
